<template>
    <div class="bigblack" v-show="show">
        <!-- 搜索start -->
        <van-search placeholder="请输入" v-model="keyword" @input='onSearch' />
        <!-- 搜索 end-->
        <van-picker title="请选择" value-key="name" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
    </div>
</template>
<script>
import { Search, Picker, Field } from 'vant';
export default {
    data() {
        return {
            pickerval: '',
            show: true,
            keyword: '',
        }
    },
    props: {
        columns: {
            type: Array,
            default() {
                return []
            }
        },
        pickerObj: {
            type: Object,
        },
    },
    components: {
        [Search.name]: Search,
        [Picker.name]: Picker,
        [Field.name]: Field
    },
    created() {
        this.pickerval = this.pickerObj.thisValue
    },
    watch: {
        pickerObj: {
            handler(val) {
                this.pickerval = this.pickerObj.thisValue
                this.show = this.pickerObj.isShow
            },
        }
    },
    mounted() {

    },
    methods: {
        onConfirm(value, index) {
            console.log("pickerEx");
            console.log(index);
            this.keyword = ''

            this.pickerval = value.name
            this.$emit('fromChild', value, index)
            this.$emit('hidePopup')
        },
        onCancel() {
            this.$emit('hidePopup')
        },
        onSearch() {
            console.log("onSearch   " + this.keyword)
            this.$emit('onSearch', this.keyword)
        }
    },
}
</script>
<style lang="less" scoped>
.content {
    font-size: 15px;

    .picker {
        font-size: 15px;
        position: relative;
        border-bottom: 1px solid #eee;

        .rediconc {
            z-index: 99;
            position: absolute;
            left: 10px;
            top: 19px;
            color: #f00;
        }

        .van-cell {
            font-size: 15px;
            height: 46px;
            line-height: 46px;
            padding: 0px 10px 0 15px;
        }

        .custom-title {
            margin-left: 5px;
        }

        /deep/.van-field__label {
            margin-left: 5px;
            width: 110px;

            span {
                font-size: 15px;
            }
        }

        /deep/.van-field__control {
            text-align: right;
        }

        /deep/.van-icon {
            line-height: 46px;
        }
    }

    .bigblack {
        height: 100%;
        width: 100%;
        z-index: 999;
        position: fixed;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.2);

        .van-picker {
            position: fixed;
            bottom: 0;
            width: 100%;
            height: 50%;
        }

        .van-pagination {
            position: absolute;
            bottom: 0%;
            z-index: 99;
            width: 100%;
        }

        .van-search {
            position: relative;
            top: 44%;
            z-index: 9999;
        }
    }
}
</style>
  